import { getAssetPath } from 'lib/utils/common/commonUtils'
import ICONS, { ICON_SIZE } from 'components/common/icon/const'

export const ASSET_PAGE_PREFIX = `${getAssetPath()}/static/img/pages/`

export const ASSETS = {
  DESKTOP_BANNER: `${ASSET_PAGE_PREFIX}referral/referral-banner-desktop2025.jpg`,
}

export const REFERRAL_LOCIZE = {
  REFERRAL_FRIENDS: {
    key: 'REFERRAL_FRIENDS',
    text: 'Refer Friends,',
  },
  REFERRAL_GIVEN_OFFERS: {
    key: 'REFERRAL_GIVEN_OFFERS',
    text: 'Get 100฿ Each',
  },
  REFERRAL_GIVEN_OFFERS_DETAIL: {
    key: 'REFERRAL_GIVEN_OFFERS_DETAIL',
    text: 'Give your friends 200฿ off on thier first purchase. When they buy with your referral code, you get 100฿ Pomelo cashback for each successful referral.',
  },
  REFERRAL_HOW_TO_EARN_TITLE: {
    key: 'REFERRAL_HOW_TO_EARN_TITLE',
    text: 'Getting Started Is Easy!',
  },
  REFERRAL_HOW_TO_EARN_SIGN_UP: {
    key: 'REFERRAL_HOW_TO_EARN_SIGN_UP',
    text: 'Sign up for Pomelo Perks* to start earning cashback.',
  },
  REFERRAL_HOW_TO_EARN_INVITE: {
    key: 'REFERRAL_HOW_TO_EARN_INVITE',
    text: 'Get referral code and share to your friends.',
  },
  REFERRAL_HOW_TO_EARN_CASH_BACK: {
    key: 'REFERRAL_HOW_TO_EARN_CASH_BACK',
    text: 'Earn cashback when your friend use your code on her first purchase.',
  },
  REFERRAL_HOW_TO_EARN_REDEEM: {
    key: 'REFERRAL_HOW_TO_EARN_REDEEM',
    text: 'Redeem Rewards on the Pomelo App, pomelofashion.com and at our stores.',
  },
  REFERRAL_LEARN_MORE: {
    key: 'REFERRAL_LEARN_MORE',
    text: 'LEARN MORE',
  },
  REFERRAL_SIGN_UP_PERKS: {
    key: 'REFERRAL_SIGN_UP_PERKS',
    text: 'Sign Up to Pomelo Perks',
  },
  REFERRAL_COPY_CODE: {
    key: 'REFERRAL_COPY_CODE',
    text: 'Copy Code',
  },
  REFERRAL_HOW_IT_WORK_TITLE: {
    key: 'REFERRAL_HOW_IT_WORK_TITLE',
    text: 'How it works',
  },
  REFERRAL_HOW_IT_WORK_FIRST_STEP: {
    key: 'REFERRAL_HOW_IT_WORK_FIRST_STEP',
    text: 'Share referral code with your friends',
  },
  REFERRAL_HOW_IT_WORK_SECOND_STEP: {
    key: 'REFERRAL_HOW_IT_WORK_SECOND_STEP',
    text: 'Your friends get 400 ฿ off 1st order',
  },
  REFERRAL_HOW_IT_WORK_THIRD_STEP: {
    key: 'REFERRAL_HOW_IT_WORK_THIRD_STEP',
    text: 'Earn free 100 ฿ Credit when your friends complete 1st order with your referral code',
  },
  REFERRAL_CHECK_BALANCE: {
    key: 'REFERRAL_CHECK_BALANCE',
    text: 'Check All Balance',
  },
  REFERRAL_SHARE_CODE_TEXT: {
    key: 'REFERRAL_SHARE_CODE_TEXT',
    text: 'Try Pomelo with me! Plus, grab 400 ฿ off 600+ brands',
  },
  REFERRAL_SHARE_CODE_TEMPLATE: {
    key: 'REFERRAL_SHARE_CODE_TEMPLATE',
    text: 'Apply this code at Checkout: %s Shop now at',
  },
  REFERRAL_TNC_TITLE: {
    key: 'REFERRAL_TNC_TITLE',
    text: 'Terms & Conditions:',
  },
  REFERRAL_TNC_TEXT: {
    key: 'REFERRAL_TNC_TEXT',
    text: `You will get the cashback rewards when your friends make a first purchase.
    Cashback may be rejected if the order is either canceled, no-show for pickup, fail delivery or payment didn’t go through.
    The referral cashback will have a 3 months expiration.`,
  },
  REFERRAL_CASHBACK_TITLE: {
    key: 'REFERRAL_CASHBACK_TITLE',
    text: 'My Referral Cashback',
  },
  REFERRAL_CASHBACK_SUB_TITLE: {
    key: 'REFERRAL_CASHBACK_SUB_TITLE',
    text: 'You will get the cashback rewards when your friends make a first purchase.',
  },
  REFERRAL_CASHBACK_ZERO_BALANCE: {
    key: 'REFERRAL_CASHBACK_ZERO_BALANCE',
    text: '0 ฿',
  },
}

export const HOW_TO_EARN_LIST = [
  {
    key: REFERRAL_LOCIZE.REFERRAL_HOW_TO_EARN_SIGN_UP.key,
    text: REFERRAL_LOCIZE.REFERRAL_HOW_TO_EARN_SIGN_UP.text,
    icon: ICONS.checkIcon,
    iconSize: ICON_SIZE.large,
  },
  {
    key: REFERRAL_LOCIZE.REFERRAL_HOW_TO_EARN_INVITE.key,
    text: REFERRAL_LOCIZE.REFERRAL_HOW_TO_EARN_INVITE.text,
    icon: ICONS.inviteIcon,
    iconSize: ICON_SIZE.large,
  },
  {
    key: REFERRAL_LOCIZE.REFERRAL_HOW_TO_EARN_CASH_BACK.key,
    text: REFERRAL_LOCIZE.REFERRAL_HOW_TO_EARN_CASH_BACK.text,
    icon: ICONS.shoppingIcon,
    iconSize: ICON_SIZE.large,
  },
  {
    key: REFERRAL_LOCIZE.REFERRAL_HOW_TO_EARN_REDEEM.key,
    text: REFERRAL_LOCIZE.REFERRAL_HOW_TO_EARN_REDEEM.text,
    icon: ICONS.rewardIcon,
    iconSize: ICON_SIZE.large,
  },
]

export const HOW_TO_WORK_LIST = [
  {
    key: REFERRAL_LOCIZE.REFERRAL_HOW_IT_WORK_FIRST_STEP.key,
    text: REFERRAL_LOCIZE.REFERRAL_HOW_IT_WORK_FIRST_STEP.text,
    icon: ICONS.referralNo1Icon,
    iconSize: ICON_SIZE.medium,
  },
  {
    key: REFERRAL_LOCIZE.REFERRAL_HOW_IT_WORK_SECOND_STEP.key,
    text: REFERRAL_LOCIZE.REFERRAL_HOW_IT_WORK_SECOND_STEP.text,
    icon: ICONS.referralNo2Icon,
    iconSize: ICON_SIZE.medium,
  },
  {
    key: REFERRAL_LOCIZE.REFERRAL_HOW_IT_WORK_THIRD_STEP.key,
    text: REFERRAL_LOCIZE.REFERRAL_HOW_IT_WORK_THIRD_STEP.text,
    icon: ICONS.referralNo3Icon,
    iconSize: ICON_SIZE.medium,
  },
]
